(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/view-options/eurojackpot.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/view-options/eurojackpot.js');

'use strict';

svs.numbergames.game.view_options.EUROJACKPOT = {
  multiHuxFluxArray: [2, 5, 10],
  drawDaysInfoDialog(attachTo) {
    svs.ui.dialog.api.add(new svs.ui.dialog.Contextual({
      branding: svs.ui.dialog.branding.TUR,
      attachTo,
      type: svs.ui.dialog.type.INFO,
      title: 'Dragning två dagar i veckan!',
      message: [{
        align: svs.ui.dialog.message.align.CENTER,
        type: svs.ui.dialog.message.TEXT,
        text: 'Du kan bli jackpotvinnare både på tisdagar och fredagar. Tänk på att jackpot växer löpande - ' + 'faller den inte ut vid första dragningen - då är den större vid nästa. Jackpot kan växa till ca 1,2 miljarder kr.'
      }]
    }));
  }
};

 })(window);